import { Unstable_Grid2 as Grid } from '@mui/material';
import { useMemo } from 'react';

import { Select } from '@occc-app/design-system';
import { useConfig } from '@occc/config';

import { optInStatusOptions } from './constants';

export type CommunicationOptInTargetingAttributeProps = {
  fieldName: string;
};

export const CommunicationOptInTargetingAttribute = ({
  fieldName,
}: CommunicationOptInTargetingAttributeProps) => {
  const { config } = useConfig();

  const subBrandsEnabled = !!config.subBrands?.enabled && (config.subBrands?.list.length ?? 0) > 0;

  const subBrandOptions = useMemo(
    () => [
      { label: 'Clear Selection', value: '' },
      ...(config.subBrands?.list ?? []).map((subBrand) => ({
        label: subBrand.name,
        value: subBrand.uuid,
      })),
    ],
    [config.subBrands?.list],
  );

  return (
    <Grid container spacing={3}>
      <Grid xs={12} sm={6} md={3}>
        <Select
          name={`${fieldName}.status`}
          label='Status'
          data={optInStatusOptions}
          formControlProps={{ size: 'medium', margin: 'none' }}
        />
      </Grid>
      {subBrandsEnabled && (
        <Grid xs={12} sm={6} md={3}>
          <Select
            name={`${fieldName}.subBrandUuid`}
            label='Sub Brand'
            data={subBrandOptions}
            formControlProps={{ size: 'medium', margin: 'none' }}
          />
        </Grid>
      )}
    </Grid>
  );
};
